import { ContentDesafio } from './ContentDesafio';
import { ChallengeResults } from './Results';
import { ChallengeNoData } from './noData';

import { MainHome } from '@/components/GenericsTournaments';
import { AdSlot } from '@/components/GoogleAds/AdSlot';
import { TabType } from '@/components/Types';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { Maybe } from '@/types';
import { ChallengeInitResponse, ChallengeUser } from '@/types/challenges';
import { EnumContextGDT } from '@/types/team';

export interface ChallengesProps {
  pendingList: ChallengeUser[];
  playingList: ChallengeUser[];
  invitationList: ChallengeUser[];
  mounted?: boolean;
  hitsJugados?: number;
  fechas?: any[];
  init?: Maybe<ChallengeInitResponse>;
  refetchFather?: () => void;
}

interface Props {
  init: ChallengesProps;
  handleRefresh: () => void;
  tabSelected?: TabType;
  tabs?: React.ReactNode;
}

export const MainContentChallenge = ({
  init: data,
  handleRefresh,
  tabSelected,
  tabs,
}: Props) => {
  const { isDesktop, isMobile } = useIsDesktop();

  const noData =
    data?.invitationList?.length === 0 &&
    data?.pendingList?.length === 0 &&
    data?.playingList?.length === 0 &&
    data?.hitsJugados === 0;

  return (
    <MainHome
      className={`w-full ${isMobile ? 'ml-4' : ''}`}
      context={EnumContextGDT.Challenge}
      subtitle={
        isDesktop || (isMobile && tabSelected === TabType.FirstTab)
          ? 'Desafiá a tus amigos a un mano a mano todas las semanas. Renová tu desafío fecha a fecha.'
          : undefined
      }
      title="Desafíos 1 a 1"
    >
      {data?.mounted && (
        <>
          <div className="px-4 md:px-0">
            {isDesktop && !noData && data.fechas && data.fechas?.length > 0 && (
              <div className="w-full flex justify-center mt-7">{tabs}</div>
            )}

            <AdSlot divId="CHALLENGES" variant="HORIZONTAL" />
          </div>
          {noData ? (
            <ChallengeNoData />
          ) : tabSelected === TabType.SecondTab ? (
            <ChallengeResults />
          ) : (
            <ContentDesafio
              hitsJugados={data.hitsJugados}
              invitationList={data?.invitationList}
              pendingList={data?.pendingList}
              playingList={data?.playingList}
              refetchFather={handleRefresh}
            />
          )}
        </>
      )}
    </MainHome>
  );
};
